import { useEffect, useState } from 'react';

export function useFont() {
    const [font, setFont] = useState('system');

    // Load font from localStorage on mount
    useEffect(() => {
        const savedFont = localStorage.getItem('app-font');
        if (savedFont) {
            setFont(savedFont);
            applyFont(savedFont);
        } else {
            // Default to system font if no saved font
            applyFont('system');
        }
    }, []);

    // Apply font to document
    const applyFont = (newFont: string) => {
        const root = document.documentElement;

        if (newFont === 'system') {
            // Use system default fonts (Vite.js default)
            root.style.setProperty('--font-family', '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif');

            // Remove Google Fonts link if exists
            const fontStyleLink = document.getElementById('font-style-link');
            if (fontStyleLink) {
                fontStyleLink.remove();
            }
        } else {
            // Use custom Google Font
            root.style.setProperty('--font-family', `"${newFont}", sans-serif`);

            // Add Google Fonts link if not already present
            const fontStyleLink = document.getElementById('font-style-link') as HTMLLinkElement;

            if (!fontStyleLink) {
                const styleLink = document.createElement('link');
                styleLink.id = 'font-style-link';
                styleLink.rel = 'stylesheet';
                styleLink.href = `https://fonts.googleapis.com/css2?family=${newFont.replace(' ', '+')}:wght@300;400;500;600;700&display=swap`;
                document.head.appendChild(styleLink);
            } else {
                fontStyleLink.href = `https://fonts.googleapis.com/css2?family=${newFont.replace(' ', '+')}:wght@300;400;500;600;700&display=swap`;
            }
        }
    };

    // Change font
    const changeFont = (newFont: string) => {
        setFont(newFont);
        localStorage.setItem('app-font', newFont);
        applyFont(newFont);
    };

    return { font, changeFont };
}
